'use strict';

/**
 * TileUtil is responsible for creating tile layer objects that are ready to be
 * passed to angular-leaflet
 */

var _ = require('lodash');

function TileUtil (sbMapConfig) {
  this.getBaseLayer = function (options) {
    return {
      mapbox: sbMapConfig.getTileLayer('mapbox', null, options)
    };
  };

  this.getTileLayers = function (layers, type, bounds, maxZoom, options) {
    return _.reduce(layers, function (layers, layer) {

      var _ref = layer._ref;

      var params = {
        bounds: layer.bounds || bounds,
        layerId: layer.layerId,
        opacity: layer.opacity || 1.0,
        _ref: _ref,
        maxNativeZoom: layer.maxNativeZoom
      };

      params = _.assign({}, options, params);
      layer = sbMapConfig.getTileLayer(type, params.layerId, params);

      layer.$show(); // make the layer visible by default
      layer._ref = _ref;
      layers[layer.name] = layer;

      return layers;
    }, {});
  };
}

TileUtil.$inject = ['sbMapConfig'];
module.exports = TileUtil;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/utils/TileUtil.js